import * as React from 'react'
import type { SVGProps } from 'react'

import { PijmaComponent } from '@pijma/helper-component'
import { CommonComponentProps } from '@pijma/hero-types'

export const IconArrowRight = (
  props: SVGProps<SVGSVGElement> & CommonComponentProps,
) => (
  <PijmaComponent
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
    as="svg"
    commonProps={props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5858 12L7.29289 19.2929C6.90237 19.6834 6.90237 20.3166 7.29289 20.7071C7.68342 21.0976 8.31658 21.0976 8.70711 20.7071L16.7071 12.7071C17.0976 12.3166 17.0976 11.6834 16.7071 11.2929L8.70711 3.29289C8.31658 2.90237 7.68342 2.90237 7.29289 3.29289C6.90237 3.68342 6.90237 4.31658 7.29289 4.70711L14.5858 12Z"
      fill="currentColor"
    />
  </PijmaComponent>
)
